<template>
  <div>
    <div class="schedule-button-container">
      <!-- <p v-if="userName" class="greeting-text">{{ userName }}様、こんにちは！</p> -->
      <p class="greeting-text">
        SukiSukiらいぶすてーしょんの資料をご覧いただきありがとうございます。
      </p>
      <p class="greeting-text">
        もし少しでもご興味をお持ちいただけましたら、<br />ぜひ一度、オンラインでご説明できれば嬉しいです。
      </p>
      <v-btn
        class="mt-5"
        height="35"
        width="230"
        rounded="pill"
        @click="showScheduleForm = true"
        color="rgb(237, 121, 149)"
      >
        <a class="login">オンライン説明を予約する</a>
      </v-btn>

      <div class="video-description">
        <p>
          まずはこちらの動画をご覧ください！<br />
          SukiSukiらいぶすてーしょんの仕組みが<br />2分15秒でわかります。
        </p>
      </div>

      <div class="youtube-container mt-5">
        <div class="youtube-wrapper">
          <iframe
            id="player"
            src="https://www.youtube.com/embed/vwuYS-hXT9c?rel=0&modestbranding=1&showinfo=0&enablejsapi=1"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>
      </div>
    </div>

    <v-dialog v-model="showScheduleForm" max-width="800" persistent>
      <v-card>
        <v-card-title class="text-h5 pa-4">
          日程を選択
          <v-btn icon @click="showScheduleForm = false" class="close-button">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-0">
          <!-- Google Calendar Appointment Scheduling begin -->
          <iframe
            src="https://calendar.google.com/calendar/appointments/schedules/AcZssZ2_Zw7-UAHspRkCfcxauqAX4Ak8ce-qKcWAKUsACo9-Kdd8vUWTuJ8D8WxM1jR4cDS04oflYne3?gv=true"
            style="border: 0"
            width="100%"
            height="600"
            frameborder="0"
          ></iframe>
          <!-- end Google Calendar Appointment Scheduling -->
        </v-card-text>
      </v-card>
    </v-dialog>

    <div v-if="isPdfLoading" class="loading">資料を読み込み中...</div>
    <div v-if="loadError" class="error">
      {{ errorMessage }}
      <button @click="reloadPage" class="reload-button">ページを更新</button>
    </div>
    <div class="pdf-description">
      <p>↓スクロールで資料をご覧いただけます。</p>
      <v-btn
        class="mt-3"
        height="35"
        width="230"
        rounded="pill"
        color="rgb(152, 45, 166)"
        :href="pdfUrl"
        target="_blank"
        rel="noopener noreferrer"
      >
        <a class="login">資料をPDFで表示する</a>
      </v-btn>
    </div>
    <div id="pdf-container" ref="pdfContainer"></div>
    <!-- フォールバックとしてPDFダウンロードリンク -->
    <p v-if="!isPdfSupported" style="margin-top: 30px">
      SukiSukiらいぶすてーしょんの資料は
      <a :href="pdfUrl" target="_blank" rel="noopener noreferrer">こちら</a
      >からダウンロードしてください。
    </p>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from "vue";
import { getFunctions, httpsCallable } from "firebase/functions";
import * as pdfjsLib from "pdfjs-dist/build/pdf";

// YouTubeプレーヤーの状態を監視するための変数
const player = ref(null);
const isHalfwayPlayed = ref(false);

// YouTube APIが読み込まれたときに呼び出される関数
const onYouTubeIframeAPIReady = () => {
  player.value = new window.YT.Player("player", {
    events: {
      onStateChange: onPlayerStateChange,
      onReady: onPlayerReady,
    },
  });
};

// プレーヤーの準備ができたときに呼び出される関数
const onPlayerReady = () => {
  console.log("YouTubeプレーヤーの準備が完了しました");
};

// プレーヤーの状態が変更されたときに呼び出される関数
const onPlayerStateChange = (event) => {
  if (event.data === window.YT.PlayerState.PLAYING && !isHalfwayPlayed.value) {
    const duration = player.value.getDuration();
    const interval = setInterval(() => {
      const currentTime = player.value.getCurrentTime();
      const progress = (currentTime / duration) * 100;

      if (progress >= 50 && !isHalfwayPlayed.value) {
        console.log("再生完了（50%以上）");
        isHalfwayPlayed.value = true;
        clearInterval(interval);

        // Firebase Functionsを呼び出す
        if (documentId) {
          const functions = getFunctions(undefined, "asia-northeast1");
          const sendToEngageForVideo = httpsCallable(functions, "sendToEngageForVideo");
          sendToEngageForVideo({ id: documentId })
            .then((response) => {
              console.log("動画視聴完了の通知を送信しました:", response.data);
            })
            .catch((error) => {
              console.error("動画視聴完了の通知に失敗しました:", error);
            });
        }
      }
    }, 1000);
  }
};

// PDF.jsのワーカースクリプトを設定
pdfjsLib.GlobalWorkerOptions.workerSrc =
  "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.4.120/pdf.worker.min.js";

// PDFファイルのURL
const pdfUrl = ref(
  "https://storage.googleapis.com/rf-prd-sukisuki-ls.appspot.com/live_station_images_common/%E3%83%AA%E3%82%A2%E3%83%AB%E3%82%BF%E3%82%A4%E3%83%A0%E3%81%8F%E3%81%97%E3%82%99%E5%BC%95%E3%81%8D%E3%80%8CSukiSuki%E3%82%89%E3%81%84%E3%81%B5%E3%82%99%E3%81%99%E3%81%A6%E3%83%BC%E3%81%97%E3%82%87%E3%82%93%E3%80%8D%E8%B3%87%E6%96%99.pdf"
);

// ユーザー名を管理
const userName = ref("");
const pdfContainer = ref(null);
const numPages = ref(0);

// Tawk.toの初期化
const initializeTawkTo = () => {
  // 既存のTawk.toスクリプトを削除
  const existingScript = document.querySelector('script[src*="tawk.to"]');
  if (existingScript) {
    existingScript.remove();
  }

  // Tawk.toの設定を初期化
  window.Tawk_API = window.Tawk_API || {};
  window.Tawk_LoadStart = new Date();

  // ユーザー名が存在する場合のみ設定
  if (userName.value) {
    window.Tawk_API.onLoad = function () {
      // 遅延時間を3秒に設定
      setTimeout(() => {
        window.Tawk_API.setAttributes(
          {
            name: userName.value,
          },
          function (error) {
            if (error) {
              console.error("Tawk.to: ユーザー名の設定に失敗しました", error);
              // 失敗した場合は3秒後に再試行
              setTimeout(() => {
                window.Tawk_API.setAttributes(
                  {
                    name: userName.value,
                  },
                  function (retryError) {
                    if (retryError) {
                      console.error("Tawk.to: 再試行も失敗しました", retryError);
                    } else {
                      console.log(
                        "Tawk.to: 再試行でユーザー名が正常に設定されました",
                        userName.value
                      );
                    }
                  }
                );
              }, 3000);
            } else {
              console.log("Tawk.to: ユーザー名が正常に設定されました", userName.value);
            }
          }
        );
      }, 3000);
    };
  }

  const s1 = document.createElement("script");
  const s0 = document.getElementsByTagName("script")[0];
  s1.async = true;
  s1.src = "https://embed.tawk.to/67f95c851284d1190717a86b/1ioj7p7c0";
  s1.charset = "UTF-8";
  s1.setAttribute("crossorigin", "*");
  s0.parentNode.insertBefore(s1, s0);
};

// PDFの読み込み状態を管理
const isPdfLoading = ref(true);
const loadError = ref(false);
const errorMessage = ref("");

// URLからクエリパラメータを取得する関数
const getQueryParam = (name) => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(name);
};

// Firebase Functionsを呼び出す関数
const result = ref(null);
const isFetchingName = ref(false);
const callFunction = async (documentId) => {
  if (isFetchingName.value) return;

  isFetchingName.value = true;
  try {
    const functions = getFunctions(undefined, "asia-northeast1");
    const getDocument = httpsCallable(functions, "sendToEngage");

    const response = await getDocument({ id: documentId });

    // 結果から名前を取得
    if (response.data && response.data.name) {
      userName.value = response.data.name;
      console.log("ユーザー名を設定しました:", userName.value);
      // 名前が取得された後にTawk.toを再初期化
      initializeTawkTo();
    } else {
      userName.value = null;
      console.warn("名前の取得に失敗しました。");
    }

    console.log("Firebase Functions レスポンス:", response.data);
  } catch (err) {
    console.error("Firebase Functions エラー:", err);
    result.value = { error: err.message };
    userName.value = null;
  } finally {
    isFetchingName.value = false;
  }
};

// URLからIDを取得
const documentId = getQueryParam("id");

// PDFをレンダリングする関数
const renderPDF = async () => {
  try {
    isPdfLoading.value = true;

    // PDFを直接URLから読み込む
    const loadingTask = pdfjsLib.getDocument({
      url: pdfUrl.value,
      cMapUrl: "https://unpkg.com/pdfjs-dist@3.4.120/cmaps/",
      cMapPacked: true,
    });

    const pdf = await loadingTask.promise;
    numPages.value = pdf.numPages;

    // コンテナの幅を取得
    const containerWidth = pdfContainer.value.clientWidth;

    for (let i = 1; i <= pdf.numPages; i++) {
      const page = await pdf.getPage(i);
      const viewport = page.getViewport({ scale: 1.0 });

      // ページのスケールをコンテナの幅に合わせて計算（高解像度用に2倍）
      const scale = ((containerWidth - 20) / viewport.width) * 2; // 余白を20pxに減らし、2倍の解像度
      const scaledViewport = page.getViewport({ scale });

      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d", { alpha: false });

      // 高解像度ディスプレイ対応
      // const dpr = window.devicePixelRatio || 1;
      const displayWidth = containerWidth - 20; // 余白を考慮
      const displayHeight = (displayWidth * viewport.height) / viewport.width; // アスペクト比を維持
      canvas.style.width = `${displayWidth}px`;
      canvas.style.height = `${displayHeight}px`;
      canvas.width = scaledViewport.width;
      canvas.height = scaledViewport.height;

      // 高品質なレンダリング設定
      context.imageSmoothingEnabled = true;
      context.imageSmoothingQuality = "high";

      const renderContext = {
        canvasContext: context,
        viewport: scaledViewport,
        intent: "print", // 高品質なレンダリング
      };

      await page.render(renderContext).promise;
      pdfContainer.value.appendChild(canvas);
    }

    isPdfLoading.value = false;
  } catch (error) {
    console.error("PDFの読み込みに失敗しました:", error);
    isPdfLoading.value = false;
    loadError.value = true;
    errorMessage.value = "資料の読み込みに失敗しました。ページを更新してください。";
  }
};

// ページを更新するメソッド
const reloadPage = () => {
  window.location.reload();
};

// コンポーネントのマウント時に実行
onMounted(() => {
  if (documentId) {
    callFunction(documentId);
  } else {
    console.log("URLにIDが指定されていないため、処理をスキップします");
    // IDがない場合はデフォルトでTawk.toを初期化
    initializeTawkTo();
  }
  renderPDF();

  // YouTube APIスクリプトを動的に読み込む
  const tag = document.createElement("script");
  tag.src = "https://www.youtube.com/iframe_api";
  const firstScriptTag = document.getElementsByTagName("script")[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

  // グローバル関数として設定
  window.onYouTubeIframeAPIReady = onYouTubeIframeAPIReady;
});

// コンポーネントのアンマウント時に実行
onUnmounted(() => {
  // クリーンアップ処理は不要になったため削除
});

// ブラウザがネイティブのPDF表示をサポートしているか確認
const isPdfSupported = ref(
  (() => {
    const canvas = document.createElement("canvas");
    return !!(canvas.getContext && canvas.getContext("2d"));
  })()
);

// 予約フォームの表示状態を管理
const showScheduleForm = ref(false);
</script>

<style scoped>
.loading {
  text-align: center;
  padding: 20px;
  font-size: 1.2em;
  color: #666;
}

.error {
  text-align: center;
  padding: 20px;
  font-size: 1.2em;
  color: #ff4444;
  background-color: #fff5f5;
  border-radius: 4px;
  margin: 10px 0;
}

.reload-button {
  display: block;
  margin: 10px auto;
  padding: 8px 16px;
  background-color: #f0acc4;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1em;
}

.reload-button:hover {
  background-color: #e89db3;
}

.schedule-button-container {
  text-align: center;
  padding: 20px;
  background-color: #fff;
  border-bottom: 1px solid #eee;
}

.greeting-text {
  margin: 10px 0;
  line-height: 1.6;
  color: #333;
}

.login {
  color: rgb(255 255 255);
  font-size: 14px;
}

.close-button {
  position: absolute;
  right: 8px;
  top: 8px;
}

.youtube-container {
  display: flex;
  justify-content: center;
  margin: 20px 0;
}

.youtube-wrapper {
  position: relative;
  width: 100%;
  max-width: 560px;
  aspect-ratio: 16 / 9;
  margin: 0 auto;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.youtube-wrapper iframe {
  border: none; /* デフォルトのボーダーを削除 */
  background-color: transparent; /* 背景色を透明に */
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  border-radius: 8px;
  z-index: 1;
}

.video-description {
  text-align: center;
  margin: 20px 0;
  line-height: 1.6;
  border-top: 1px solid #eee;
  padding-top: 20px;
}

.video-description p {
  margin: 0;
}

#pdf-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

@media (max-width: 768px) {
  #pdf-container {
    padding: 0;
    gap: 0;
    max-width: 100%;
  }
  #pdf-container canvas {
    width: 100%;
    max-width: 100%;
    border-radius: 0;
    margin: 0;
    padding: 0;
  }
}

#pdf-container canvas {
  width: 100%;
  height: auto;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  image-rendering: -webkit-optimize-contrast; /* 高品質な画像レンダリング */
}

.pdf-description {
  text-align: center;
  padding: 20px;
  font-size: 16px;
  color: #333;
  margin: 20px auto;
  max-width: 1200px;
}

.pdf-description .v-btn {
  margin-top: 15px;
}
</style>
